import { useEffect, useState } from 'react';
import CircularWithValueLabel from '../../components/circular-progress';
import EagleTracker from '../../components/eagle-tracker';

const MSOfficePage = (prop) => {
  const { eagleCount, prevEagleCount } = prop;
  const [ isLoading, setIsLoading ] = useState(true);
  const [ isPlaying, setIsPlaying ] = useState(false);

  useEffect(() => {
    console.log(`Eagle tracker: ${(isPlaying ? 'Play' : 'Stop')}`);
    var timeoutId = null;
    if (!isPlaying) { 
      timeoutId = setTimeout(() => {
        setIsPlaying(true);
      }, 1000);
    }
    return () => clearTimeout(timeoutId);
  }, [ isPlaying ]);

  return (
    <div>
      {isLoading ? <CircularWithValueLabel /> : null}
      <EagleTracker 
        eagleCount={eagleCount} 
        prevEagleCount={prevEagleCount} 
        canPlay={isPlaying}
        takeoverMode={false}
        setIsLoading={setIsLoading}
        setIsPlaying={setIsPlaying} />
    </div>
  );
};

export default MSOfficePage;
